// Product ID to single Variant ID mapping
let tangent_selected_product_map;

const default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const outOfStockText = "Out of Stock";
const noProductsText ="No products found. Please retry!";
let domainCurrency;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={
  section_basics:"Basics",
  section_essentials:"Essentials",
  section_works:"Works"
}

// Add default image url here
const tangentDefaultSelfie="https://file.tangent.ai/quiz-content/merchants/debbd0-16/image/21249167815532166-48e04cedfc50970dca20850960f4a0db.webp";

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

const tangent_account_type = document.querySelector("#tangent_account_type"); 
const pricing_enabled = tangent_account_type && tangent_account_type.innerHTML === "retail";

document.addEventListener("DOMContentLoaded", () => {
  const responseId = getClientResponseId();

  if (responseId) {
    checkoutDataApiCall(responseId);
  }
});

function getClientResponseId() {
  return new URL(window.location.href).searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response) {
  const {
    products,
    product_sections: productSections,
    text_sections: textSections,
    selected_variants: selectedVariants,
    selfie_id: selfieId,
    tags,
    description
  } = response;

  initializeCurrency();

  setupSelfie(response, selfieId);

  if (productSections) {
    createProductSection(productSections, textSections);
  }

  setTabOpen(tags);

  if (textSections) {
    createTextSection(productSections, textSections);
  }

  renderProducts(products, productSections, selectedVariants);

  toggleDescription(description);
}

function initializeCurrency() {
  domainCurrency =
    document.getElementById("tangent_client_currency")?.textContent || "$";
}

function setupSelfie(response, selfieId) {
  setTangentSelfieSection(response);

  if (selfieId) {
    setSelfieId(selfieId);
    getSelfieMapping(selfieId);
    enableSelfieDependedStaticElements();
  }

  setElementDisplay("section_selfie_container_parent", "flex");
}

function renderProducts(products, productSections, selectedVariants) {
  if (products?.length) {
    setProductsToView(products, productSections, selectedVariants);
    loadElementsOnResponseData();
    return;
  }

  const generalText = document.getElementById("tangent-general-text");
  if (generalText) {
    generalText.textContent = noProductsText;
  }
}

function toggleDescription(description) {
  if (!description) {
    setElementDisplay("tangent-general-text", "block");
  }
}

function setProductsToView(products, sections, selectedVariants) {
  tangent_selected_product_map = {};

  // Create a lookup map once
  const productMap = Object.fromEntries(
    products.map(product => [String(product.id), product])
  );

  Object.entries(sections).forEach(([section, productIds]) => {
    const productGrid = document.getElementById(`${section}_product_grid`);
    if (!productGrid) return;

    const fragment = document.createDocumentFragment();

    productIds.forEach((productId, sectionIndex) => {
      const product = productMap[productId];
      if (!product) return;

      const variant = getSelectedVariant(product, selectedVariants[product.id]);
      const variantId = extractShopifyNumericId(variant.id);

      tangent_selected_product_map[product.id] = variantId;

      const temp = document.createElement("div");
      temp.innerHTML = getProductHTML(
        product,
        product.id,
        variant,
        section,
        sections,
        variantId,
        sectionIndex
      );

      fragment.append(...temp.childNodes);
    });

    productGrid.appendChild(fragment);
  });
}

function getProductDescription(product){
  const description = product?.product_description?.value?.trim() || '';
  if (description !== '') {
    return `<p class="tangent_product_description">${description}</p>`;
  }
  return '';
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => extractShopifyNumericId(variant.node.id) === selectedVariantId) || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

function extractShopifyNumericId(gid) {
  if (typeof gid !== 'string') return null;

  const match = gid.match(/\d+$/);
  return match ? match[0] : null;
}

function isEvenIndex(index) {
  return index % 2 === 0;
}

function getProductHTML(product, index, variant, section, sections, variantId, sectionIndex) {
  const customClass = isEvenIndex(sectionIndex) ? "" : "reverse-product-card";
  const imageUrl = getVariantImage(variant, product);
  const productUrl = `${product.onlineStoreUrl}?variant=${variantId}`;

  if (pricing_enabled && isProductAvailable(product, variant)) {
    updateSectionAllToCartLink(section, product, sections, variantId);
  }

  return `
    <div class="tangent-product-card ${customClass}">
      <div class="product-image-container">
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${productUrl}">
          <img id="image_tangent_product_${index}" src="${imageUrl}" class="tangent_product_image" alt="${product.title}">
        </a>
      </div>

      <div class="product-content-container">
        <p class="tangent-product-title tangent_product_title_text"><b>${product.title}</b></p>
        ${getProductDescription(product)}
        ${getPricingHTML(product, variant, index, variantId)}
      </div>
    </div>
  `;
}

function getPricingHTML(product, variant, index, variantId) {
  if (window.customerIsBlocked) return "";
  if (!pricing_enabled) return "";

  const available = isProductAvailable(product, variant);

  return `
    <p id="price_tangent_product_${index}" class="tangent_product_price_text">
      ${domainCurrency}${variant.price}
    </p>

    <button
      id="${variantId}"
      class="tangent-product-add-btn-wrapper tangent_add_to_cart_button tangent-btn-add ${available ? "" : "disable-btn-wrapper"}"
      data-add-to-cart="${variantId}"
      onclick="addToCart(this)">
      ${available ? default_addToCartText : outOfStockText}
    </button>
  `;
}

const getVariantImage = (variant, product) => {
  const fallbackImage = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';

  if (variant?.image?.url) {
    return variant.image.url;
  }

  if (product?.images?.nodes?.length > 0 && product.images.nodes[0].url) {
    return product.images.nodes[0].url;
  }

  return fallbackImage;
};

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}


const setTabOpen = (tags) => {
    // Show the tab wrapper
  
    setElementDisplay("tab-wrapper", "block");

    // Get all tabs and tab links
    const tabContents = document.querySelectorAll(".tabcontent");
    const tabLinks = document.querySelectorAll(".tablinks");

    // Hide all tabs and remove 'active' class from all links
    tabContents.forEach(tab => (tab.style.display = "none"));
    tabLinks.forEach(link => link.classList.remove("active"));

    // Determine which tab to show
    let activeIndex = 2; // Default to the third tab
    if (tags.includes("routine_5_mins")) {
        activeIndex = 0;
    } else if (tags.includes("routine_10_mins")) {
        activeIndex = 1;
    }
    // Set the selected tab active
    tabContents[activeIndex].style.display = "block";
    tabLinks[activeIndex].classList.add("active");
};

// Updating add all to cart object for sections
function updateSectionAllToCartLink(productSections, productId, variantId) {
  if (!productSections) return;

  const productIdStr = String(productId);

  for (const section in productSections) {
    if (!productSections[section].includes(productIdStr)) continue;

    const sectionData = getSectionCartData(section);

    if (sectionData.list.includes(variantId)) continue;

    sectionData.count++;
    sectionData.cart_link += `&id[]=${variantId}`;
    sectionData.list.push(variantId);

    toggleAddAllButton(section, sectionData.count > 1);
  }
}

function getSectionCartData(section) {
  if (!sections_add_to_cart_map[section]) {
    sections_add_to_cart_map[section] = {
      count: 0,
      cart_link: `${tangent_client_domain_url}/cart/add?`,
      list: []
    };
  }

  return sections_add_to_cart_map[section];
}

function toggleAddAllButton(section, show) {
  const button = document.getElementById(`${section}_add_all_to_cart`);
  if (button) {
    button.style.display = show ? "block" : "none";
  }
}

const setElementDisplay = (element_id, displayType) => {
  const element = document.getElementById(element_id);
  if (!element) return;
  
  element.style.display = displayType;
}

// Add all to cart function for sections
function addAllTocartFunction(section) {  
    if(sections_add_to_cart_map[section]!=undefined){
        document.getElementById(section+"_add_all_cart_link").setAttribute("href", sections_add_to_cart_map[section].cart_link);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

function createFormDataFromIds(idArray) {
    return {
        items: idArray.map(id => ({
        id: id,
        quantity: 1
        }))
    };
}

function addToCart(element){ 
    if (window.customerIsBlocked) return;
    const formData = createFormDataFromIds([element.id]);
    addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
    if (window.customerIsBlocked) return;
    const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
    if(formData){
        addToCartApi(formData, element);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

function addToCartApi(payload, element){ 
  if (window.customerIsBlocked) return;
  element.innerHTML = `<div class="btn-loader button-loader">&nbsp;</div>`;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  .then(async (response) => {
    const data = await response.json();

    if (!response.ok) {
      throw data;
    }
    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 
    // document.querySelector('cart-drawer')?.renderContents(data);
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new Event('cart_page:updated'));

    const drawerSelectEl = document.querySelector('#cart-icon-bubble');
    drawerSelectEl?.click();

    return data;
  })
  .catch((error) => {
    if (error && error.status) {
      const message = error.message || "Something went wrong";

      element.innerHTML = "Add to Cart";
      element.classList.remove("added-to-cart-style");

      showCartError(element, message);
    } 
  });
}

// Main section container
function createSectionContainer(sectionName) {
  const container = document.createElement("div");
  container.id = `${sectionName}_container`;
  container.classList.add("tabcontent");

  return container;
}

// Add to cart button for sections
function createSectionAddAllToCart(sectionName) {
  const link = document.createElement("a");
  link.id = `${sectionName}_add_all_cart_link`;
  link.href = "#";
  link.classList.add(
    "section_add_all_cart_link",
    `${sectionName}_add_all_cart_link`
  );

  const text = document.createElement("p");
  text.id = `${sectionName}_add_all_to_cart`;
  text.classList.add(
    "section_add_all_to_cart",
    `${sectionName}_add_all_to_cart`
  );
  text.textContent = default_add_all_to_cart_text;

  link.appendChild(text);

  link.addEventListener("click", (event) => {
    event.preventDefault();
    addAllTocartFunction(sectionName);
  });

  return link;
}

// Container having individual products
function addSectionProductGridContainer(sectionName) {
  const container = document.createElement("div");

  container.id = `${sectionName}_product_grid`;
  container.classList.add(
    "section_product_grid",
    `${sectionName}_product_grid`
  );

  return container;
}

// Tab button
function createTabButton(sectionName) {
  const button = document.createElement("button");

  button.id = `${sectionName}_tab_button`;
  button.name = sectionName;
  button.textContent = getTabTitle(sectionName);
  button.classList.add("tablinks");
  button.addEventListener("click", () => switchTab(button));

  tangent_custom_tabs.appendChild(button);
}

function getTabTitle(sectionName) {
  return (
    tabs_title_mapping[sectionName] ??
    sectionName
      .replace("section_", "")
      .replace(/_/g, " ")
      .toUpperCase()
  );
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
      createTabButton(section_name);
    }
}

function createTextSectionBeforeProducts(textSections, sectionContainer, sectionName) {
  const content = textSections[sectionName];
  if (!content) return;

  sectionContainer.appendChild(createTextContainer(sectionName, content));
}

// Section Text Creation (one without a product section)
function createTextSection(productSections, textSections) {
  const selfieContainer = document.getElementById("section_selfie_container_parent");

  for (const sectionName in textSections) {
    if (productSections[sectionName]) continue;

    const sectionContainer = createSectionContainer(sectionName);
    sectionContainer.appendChild(createTextContainer(sectionName, textSections[sectionName]));

    if (sectionName === "section_selfie" && selfieContainer) {
      sectionContainer.classList.remove("tabcontent");
      selfieContainer.appendChild(sectionContainer);
    } else {
      tangent_sections_wrapper_element.appendChild(sectionContainer);
    }
  }
}

function createTextContainer(sectionName, content) {
  const container = document.createElement("div");
  container.id = `${sectionName}_text_container`;
  container.classList.add("section_text_container", `${sectionName}_text_container`);
  container.innerHTML = content.join(" ");
  return container;
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
  const canvasImg = document.querySelector("#canvas_img");
  const defaultImg = document.querySelector("#tangent_default_selfie_image");

  if (response?.selfie_url) {
    if (canvasImg) {
      canvasImg.src = response.selfie_url;
    }
    return;
  }

  if (tangentDefaultSelfie) {
    setElementDisplay("loading-section", "none");
    setElementDisplay("tangent_default_selfie_image", "flex");

    if (defaultImg) {
      defaultImg.src = tangentDefaultSelfie;
    }
  } else {
    setElementDisplay("tangent_selfie_container", "none");
  }
}

// Handle Tab button selection
function switchTab(element) {
  if (!element?.name) return;

  // Hide all tab contents
  document.querySelectorAll(".tabcontent").forEach(tab => {
    tab.style.display = "none";
  });

  // Remove active class from all tab buttons
  document.querySelectorAll(".tablinks").forEach(tab => {
    tab.classList.remove("active");
  });

  // Show selected tab
  const containerId = `${element.name}_container`;
  const button = document.getElementById(`${element.name}_tab_button`);

  setElementDisplay(containerId, "flex");

  if (button) {
    button.classList.add("active");
  }
}

function loadElementsOnResponseData() {
  document.querySelectorAll(".load-on-data").forEach(element => {
    element.style.display = "";
  });
}

// Selfie Mapping data API call
function getSelfieMapping(selfie_id) {
  if (!selfie_id) return;

  const selfieApiUrl = `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${encodeURIComponent(selfie_id)}&user=mango`;
  const xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    if (xhr.readyState !== XMLHttpRequest.DONE) return;

    if (xhr.status === 200) {
      handleSelfieMappingResponse(xhr.responseText);
    } else {
      console.error(`Selfie mapping request failed. Status: ${xhr.status}`);
    }
  };

  xhr.open("GET", selfieApiUrl, true);
  xhr.send();
}

function handleSelfieMappingResponse(responseText) {
  try {
    const response = JSON.parse(responseText);
    const facemap = response?.selfie_record?.[0]?.facemap;

    if (facemap) {
      tangent_facemap_data = facemap;
      updateFacemapData(facemap);
    }

    showSelfieSection();

  } catch (error) {
    console.error("Failed to parse selfie mapping response:", error);
  }
}

function updateFacemapData(facemap) {
  if (facemap.scores) {
    setScores(facemap.scores);
  }

  if (facemap.url) {
    const canvasImg = document.querySelector("#canvas_img");
    if (canvasImg) {
      canvasImg.src = facemap.url;
    }
  }
}

function showSelfieSection() {
  setElementDisplay("hideHighlight", "block");
  setElementDisplay("loading-section", "none");
  setElementDisplay("canvas_img", "block");
}

// Setting scores below the selfie
function setScores(scores) {
  if (!scores) return;

  const scoreMap = {
    acne: "Acne",
    rosacea: "Rosacea",
    darkspots: "DarkSpots",
    wrinkles: "Wrinkles",
    dark_circles: "DarkCircles",
    texture: "Texture"
  };

  let scoresPresent = false;

  Object.entries(scores).forEach(([key, value]) => {
    const concern = scoreMap[key];
    if (!concern) return;

    showScore(concern, value);
    scoresPresent = true;
  });

  if (scoresPresent) {
    setElementDisplay("facemap_all_scores_container", "flex");
  }
}

function showScore(concern, value) {
  setElementDisplay(`${concern}_Score_container`, "flex");

  const scoreElement = document.getElementById(`${concern}_Score`);
  if (scoreElement) {
    scoreElement.textContent = value;
  }
}

function enableSelfieDependedStaticElements() {
  [
    "tangent_score_description",
    "skin-health-title-container"
  ].forEach(id => setElementDisplay(id, "block"));
}

function toggleElementDisplay(id, display) {
  const element = document.getElementById(id);
  if (element) {
    element.style.display = display;
  }
}

// Toggle hide/show highlight
function toggleHighlight(showHighlight) {
  toggleElementDisplay("hideHighlight", showHighlight ? "block" : "none");
  toggleElementDisplay("showHighlight", showHighlight ? "none" : "block");
  toggleElementDisplay("selfie_canvas", showHighlight ? "block" : "none");
}

function setSelfieId(id){
  tangent_selfie_id = id;
}

function getSelfieId(){
  return tangent_selfie_id;
}

// Called on image on load function
function drawOnCanvas(){
    if(getSelfieId()!=null){
      
      var selfie_canvas = document.querySelector('#selfie_canvas');
      var selfie_canvas_ctx = selfie_canvas.getContext('2d');
      
      selfie_canvas.addEventListener('click', function(e) {
          getCursorPosition(selfie_canvas, e)
      });
      
      var canvas_img = document.querySelector('#canvas_img');
      setCanvasDimensions(selfie_canvas, canvas_img);
      
      var prop = getImageSize(canvas_img.naturalWidth);
      
      drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
      drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
      drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
      drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
      drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
      drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"],getAcneLineWidth(prop));
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
  selfie_canvas.width  = canvas_img.naturalWidth;
  selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
  var prop =  imgWidth/400;
  return prop;
}

const getDarkCircleBlur = (prop) => {
  if(prop<1){
    return 'blur(1px)';
  }
  else if(prop<1.5){
    return 'blur(2px)';
  }
  else if(prop<2){
    return 'blur(4px)';
  }
  else if(prop<3){
    return 'blur(7px)';
  }
  else if(prop<4){
    return 'blur(12px)';
  }
  else{
    
  }
}

const getRosaceaBlur = (prop) => {
  if(prop<1){
    return 'blur(4px)';
  }
  else if(prop<1.5){
    return 'blur(4px)';
  }
  else if(prop<2){
    return 'blur(5px)';
  }
  else if(prop<3){
    return 'blur(13px)';
  }
  else if(prop<4){
    return 'blur(18px)';
  }
  else{
    console.log("out of bound props - Rosacea");
  }
}

const getAcneLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 7;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - Acne");    
  }
}

const getDarkSpotsLineWidth = (prop) => {
  if(prop<1){
    return 1;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 6;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - DarkSpots");    
  }
}

const getTextureLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 3;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 16;
  }
  else{
    return 20;
  }
}

const getWrinkleLineWidth = (prop) => {
  if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 15;
  }
  else if(prop<4){
    return 30;
  }
  else{
    console.log("out of bound props - Wrinkle");    
  }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(28, 30, 82, 0.3)';
  drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
  context.fillStyle = 'rgba(24, 96, 3, 0.5)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(24, 96, 3, 0.5)";
  drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(206, 66, 66, 0.5)';
  drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
  context.lineWidth = lineWidth;
  context.filter = 'none';
  context.strokeStyle = "rgba(186, 111, 223, 0.5)";
  drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
  context.fillStyle = 'rgba(81, 212, 191, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(81, 212, 191, 0.4)";
  drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
  context.fillStyle = 'rgba(234, 220, 96, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(234, 220, 96, 0.4)";
  drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
  for (let i = 0; i < contours.length; i++) {
    drawContour(context, contours[i], fill, stroke)
  }
}

const drawContour = (context, contour_coordinates, fill=false, stroke=false) => {
  context.beginPath();
  for (let i = 0; i < contour_coordinates.length; i++) {
    let point = contour_coordinates[i]
    if (i == 0) {
      context.moveTo(point[0], point[1]);
    } else {
      context.lineTo(point[0], point[1]);
    }
  }
  context.closePath();
  if (fill) context.fill();
  if (stroke) context.stroke();
}
